import script from "./AIBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./AIBanner.vue?vue&type=script&setup=true&lang=js"

import "./AIBanner.vue?vue&type=style&index=0&id=f0c1b98c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0c1b98c"]])

export default __exports__